import {
  ADD_ITEM_TO_CART,
  ADD_MULTIPLE_ITEMS_TO_CART,
  REMOVE_ITEM_FROM_CART,
  CLEAR_ITEMS_IN_CART,
  UPDATE_ITEMS_IN_CART
} from "../actions";

export function addItemToCart(payload) {
  return {
    type: ADD_ITEM_TO_CART,
    payload
  };
}

export function addMultipleItemToCart(payload) {
  return {
    type: ADD_MULTIPLE_ITEMS_TO_CART,
    payload
  };
}

export function removeItemFromCart(payload) {
  return {
    type: REMOVE_ITEM_FROM_CART,
    payload
  };
}

export function clearItemsInCart() {
  return {
    type: CLEAR_ITEMS_IN_CART
  };
}

export function updateItemsInCart(payload) {
  return {
    type: UPDATE_ITEMS_IN_CART,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/cartItems.js